// Simple Gallery Modal
document.addEventListener('DOMContentLoaded', function() {
    // Find all gallery blocks
    const galleryBlocks = document.querySelectorAll('.gallery-block');
    
    galleryBlocks.forEach(function(galleryBlock) {
        const galleryImages = galleryBlock.querySelectorAll('.gallery-image-wrapper[data-gallery-trigger]');
        
        galleryImages.forEach(function(imageWrapper, index) {
            imageWrapper.addEventListener('click', function(e) {
                e.preventDefault();
                
                let currentIndex = index;
                
                let currentModal = null;
                
                function showImage(idx, isFirst = false) {
                    const currentWrapper = galleryImages[idx];
                    const imageUrl = currentWrapper.getAttribute('data-image-url');
                    const imageTitle = currentWrapper.getAttribute('data-title');
                    
                    if (!currentModal) {
                        // Create new modal for first time
                        currentModal = document.createElement('div');
                        currentModal.innerHTML = `
                            <div class="gallery-block__modal-overlay">
                                <div class="gallery-block__modal-content">
                                    <div class="gallery-block__modal-image-container">
                                        <img class="gallery-block__modal-image" src="${imageUrl}" alt="${imageTitle}">
                                        <button class="gallery-block__modal-close" onclick="event.stopPropagation(); closeModal()">×</button>
                                        ${galleryImages.length > 1 ? `
                                            <button class="gallery-block__modal-prev">‹</button>
                                            <button class="gallery-block__modal-next">›</button>
                                        ` : ''}
                                    </div>
                                    <div class="gallery-block__modal-footer">
                                        <p class="gallery-block__modal-title">${imageTitle}</p>
                                    </div>
                                </div>
                            </div>
                        `;
                        
                        // Close modal function
                        window.closeModal = function() {
                            const overlay = currentModal.querySelector('.gallery-block__modal-overlay');
                            const content = currentModal.querySelector('.gallery-block__modal-content');
                            
                            overlay.classList.add('gallery-block__modal-overlay--closing');
                            content.classList.add('gallery-block__modal-content--closing');
                            
                            setTimeout(() => {
                                currentModal.remove();
                                currentModal = null;
                                document.removeEventListener('keydown', handleKeydown);
                                delete window.closeModal;
                            }, 300);
                        };
                        
                        // Add event listeners for navigation
                        const prevBtn = currentModal.querySelector('.gallery-block__modal-prev');
                        const nextBtn = currentModal.querySelector('.gallery-block__modal-next');
                        
                        if (prevBtn) {
                            prevBtn.addEventListener('click', function(e) {
                                e.stopPropagation();
                                changeImage(currentIndex > 0 ? currentIndex - 1 : galleryImages.length - 1);
                            });
                        }
                        
                        if (nextBtn) {
                            nextBtn.addEventListener('click', function(e) {
                                e.stopPropagation();
                                changeImage(currentIndex < galleryImages.length - 1 ? currentIndex + 1 : 0);
                            });
                        }
                        
                        // Keyboard navigation
                        function handleKeydown(e) {
                            if (e.key === 'Escape') {
                                closeModal();
                            } else if (e.key === 'ArrowLeft') {
                                changeImage(currentIndex > 0 ? currentIndex - 1 : galleryImages.length - 1);
                            } else if (e.key === 'ArrowRight') {
                                changeImage(currentIndex < galleryImages.length - 1 ? currentIndex + 1 : 0);
                            }
                        }
                        
                        document.addEventListener('keydown', handleKeydown);
                        
                        // Add overlay click handler
                        const overlay = currentModal.querySelector('.gallery-block__modal-overlay');
                        overlay.addEventListener('click', (e) => {
                            if (e.target === overlay) {
                                closeModal();
                            }
                        });
                        document.body.appendChild(currentModal);
                        
                        // Fade in animation for first time
                        setTimeout(() => {
                            const overlay = currentModal.querySelector('.gallery-block__modal-overlay');
                            const content = currentModal.querySelector('.gallery-block__modal-content');
                            const image = currentModal.querySelector('.gallery-block__modal-image');
                            const title = currentModal.querySelector('.gallery-block__modal-title');
                            
                            overlay.classList.add('gallery-block__modal-overlay--visible');
                            content.classList.add('gallery-block__modal-content--visible');
                            
                            // Fade in image and title after modal appears
                            setTimeout(() => {
                                image.classList.add('gallery-block__modal-image--visible');
                                title.classList.add('gallery-block__modal-title--visible');
                            }, 150);
                        }, 10);
                    } else {
                        // Just change the image in existing modal
                        const image = currentModal.querySelector('.gallery-block__modal-image');
                        const title = currentModal.querySelector('.gallery-block__modal-title');
                        
                        image.classList.remove('gallery-block__modal-image--visible');
                        title.classList.remove('gallery-block__modal-title--visible');
                        
                        setTimeout(() => {
                            image.src = imageUrl;
                            image.alt = imageTitle;
                            title.textContent = imageTitle;
                            image.classList.add('gallery-block__modal-image--visible');
                            title.classList.add('gallery-block__modal-title--visible');
                        }, 200);
                    }
                }
                
                function changeImage(newIndex) {
                    currentIndex = newIndex;
                    showImage(currentIndex);
                }
                
                showImage(currentIndex);
            });
        });
    });
});